import type { companyagreementApi } from 'app/src/services/welfareportal'
import { Image } from 'app/src/shared/components/Image'
import { Card } from 'primereact/card'
import { type ReactElement } from 'react'

export function CategoryCard(props: {
  macroCategoryId: string
  category: companyagreementApi.Category
  onSelection: () => void
}): ReactElement {
  const imgHeader: ReactElement = (
    <div>
      <Image
        aria-hidden
        src={props.category.mainImage}
        imageStyle={{ height: '150px', objectFit: 'cover' }}
        alt={props.category.categoryName}
        className='rounded'
        data-testid='hide-in-storybook'
      />
    </div>
  )
  return (
    <Card
      data-testid='CategoryCard'
      onClick={props.onSelection}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          props.onSelection()
        }
      }}
      header={imgHeader}
      className='m-4 cursor-pointer p-4'
      tabIndex={0}
      role='link'
      pt={{
        body: { className: 'p-0 m-0' },
        root: { className: 'select-none' },
        content: { className: 'pt-[10px] pb-[10px]' },
      }}
    >
      <p className='m-0 mt-3 line-clamp-2 h-[50px] p-0 font-[700] text-[var(--primary-color)]'>{props.category.categoryName}</p>
    </Card>
  )
}
